<template>

  <article class="">
    <cabecera></cabecera>
    <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>¿Quiénes somos?</h2>
    </section>
    <section class="cont-1300">
      <div class="left">
        <h2>
          Nuestros comienzos
        </h2>
        <p>
          El desafío comenzó hace tiempo cuando la sociedad integrada por <strong>YPF S.A., Petrobras y Dow Argentina </strong> decidió a mediados de 1997 concretar un proyecto que explotara integralmente el gas natural.<br><br>

          Así, con la concreción del mismo, los componentes ricos del gas natural pasaron a constituir el insumo básico de la industria petroquímica, permitiendo la expansión de dicha industria fundamental para el crecimiento de la economía argentina.
        </p>
      </div>
      <a  class="right">
       <img src="./1.png" alt="">
       
      </a>
    </section>
   <section class="cont-1300 left">
      <div class="right">
       <img src="./1.jpg" alt="">
      </div>
   
      <div class="left">
        <h2>
         Nuestra empresa
        </h2>
        <p>
         Somos una empresa argentina líder en la industria del gas y la petroquímica. Desde 2001 somos un actor clave en el procesamiento del gas natural de la Cuenca Neuquina.<br>

         Agregamos valor al gas natural a través de la separación y el fraccionamiento de sus componentes ricos. Recuperamos etano, materia prima principal de la industria petroquímica, <strong>propano, butano y gasolina natural.</strong><br>

         Nuestros productos abastecen al mercado doméstico y a distintos mercados del mundo, cumpliendo con los estándares más exigentes de calidad internacional. Es una sociedad anónima cuyos accionistas son YPF (38%), Petrobras (34%) y Dow (28%).
        </p>
      </div>
     </section>
     <section class="instalaciones">
         <h1>Nuestras instalaciones</h1>
       <div class="cont-1299">
        <div class="mod">
          <div class="derecha">
            <h3>Planta Separadora Loma La Lata – Neuquén</h3>
            <p>
              Ubicada en el corazón de la formación de hidrocarburos no convencionales Vaca Muerta.<br><br>

              Se abastece por una corriente de gas natural de aproximadamente 40 millones de metros cúbicos estándar por día para alimentar el proceso en el que se retienen líquidos por el equivalente de aproximadamente 5 millones de metros cúbicos por día, retornando el "gas seco" o metano a YPF S.A. que lo inyecta en los sistemas troncales de transporte de gas natural (NEUBA II, CENTRO OESTE Y PACIFICO). <br><br>

              Los líquidos retenidos son transportados a través del poliducto de 12 pulgadas de diámetro.
            </p>
            <a target="_blank" href="https://www.youtube.com/watch?v=Oyc1XsNhQg8" >Ver video </a>
          </div>
          <div class="zurda">
              <ul class="owl-carousel">
                <li class="slide slide1">
                <a target="_blank" href="https://www.youtube.com/watch?v=Oyc1XsNhQg8"><img src="./2.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./3.jpg"  alt="">
                </li>
              </ul>
          </div>
         <!--  <div class="pop">
            <video controls  src="./video1.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
        </div>
        <!-- <div class="mod">
          <video controls  src="./video1.mp4"></video>
        </div> -->
        <div class="mod">
         <!--  <div class="pop1">
            <video controls  src="./video2.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
          <div class="derecha derechas">
            <h3>GASODUCTO TRATAYEN</h3>
            <p><strong>Neuquén</strong></p>
            <p>
             La obra del gasoducto Tratayen representa una importante inversión para nuestro esquema de abastecimiento productivo, porque nos permite captar parte del gas proveniente del yacimiento Fortín de Piedra y de los futuros desarrollos asociados a la formación Vaca Muerta.
            </p>
            <a target="_blank" href="https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be">Ver video </a>
          </div>
          <div class="zurda zurdas">
              <ul class="owl-carousel">
                <li class="slide slide1">
                  <a target="_blank"  href="https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be"><img src="./4.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./5.jpg"  alt="">
                </li>
              </ul>
          </div>
        </div>
        <!-- <div class="mod">
           <video controls  src="./video2.mp4"></video>
        </div> -->
        <div class="mod">
           <!-- <div class="pop2">
            <video controls  src="./video3.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
          <div class="derecha">
            <h3>Planta Fraccionadora Bahía Blanca </h3>
            <p>
              Situada dentro del Polo Petroquímico más importante del país: Buenos Aires. <br><br>

             
              En la planta se fraccionan los líquidos, obteniéndose etano,
              propano, butano y gasolina natural. Además, presenta
              instalaciones especialmente construidas para el almacenamiento y despacho de propano, butano y gasolina natural.<br><br>

              Cuenta con la ventaja competitiva de tener un extraordinario muelle ubicado sobre el canal de Acceso del Complejo Portuario de Bahía Blanca, único puerto de aguas profundas del país, que permite la exportación de productos en buques de gran porte.
            </p>
            <a target="_blank" href="https://www.youtube.com/watch?v=k1anD59igqU">Ver video </a>
          </div>
          <div class="zurda">
              <ul class="owl-carousel">
                <li class="slide slide1">
                  <a target="_blank" href="https://www.youtube.com/watch?v=k1anD59igqU"><img class="tercer-btn" src="./6.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./7.jpg"  alt="">
                </li>
              </ul>
          </div>
        </div>
        <!-- <div class="mod">
          <video controls  src="./video3.mp4"></video>
        </div> -->
        <div class="mod">
          <!--  <div class="pop3">
            <video controls  src="./video4.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
          <div class="derecha derechas">
            <h3>Poliducto de 600 km de longitud</h3>
       
            <p>
             Único ducto en Argentina que vincula Vaca Muerta con el puerto internacional de aguas profundas en Bahía Blanca. <br><br>

             Un caño de 12 pulgadas de diámetro que en su trayecto une ambas plantas, atravesando 4 provincias: Neuquén, Río Negro, La Pampa y Buenos Aires.
            </p>
            <p style="margin-bottom: 25px"> <a target="_blank" href="static/pdf/Folleto-A4-Mega-v2.pdf"> Prevención y Seguridad<i class="icon-file-pdf"></i></a></p>
            <a target="_blank" href="https://www.youtube.com/watch?v=LrcJP42NSmI" >Ver video </a>
          </div>
          <div class="zurda zurdas">
              <ul class="owl-carousel">
                <li class="slide slide1">
                  <a target="_blank" href="https://www.youtube.com/watch?v=LrcJP42NSmI"><img class="cuarto-btn" src="./8.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./9.jpg"  alt="">
                </li>
              </ul>
          </div>

        </div>
        <!-- <div class="mod">
          <video controls  src="./video4.mp4"></video>
        </div> -->
       </div>

     </section>
      <span id="comercializacion"></span>
     <section class="comercio">
        <h1 >Proceso Productivo y Comercial</h1>
      <div class="cont-1170">
        <img src="./2.png"  alt="">
        <video controls src="./video2.mp4"></video>
      </div>
    </section>
    <pie></pie>
  </article>
</template>

<script>
import $ from 'jquery'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'
import Cabecera from '@/components/Cabecera'
import Pie from '@/components/Pie'
export default {
  name: 'quienesSomos',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function () {
    $('.zurda > ul').owlCarousel({
      autoplay: true,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: false
    })
  },
  components: {
    Cabecera,
    Pie
  }
}

$(document).ready(function () {
  $('.primer-btn').click(function () {
    $('.pop').addClass('act-pop')
  })
  $('.second-btn').click(function () {
    $('.pop1').addClass('act-pop')
  })
  $('.tercer-btn').click(function () {
    $('.pop2').addClass('act-pop')
  })
  $('.cuarto-btn').click(function () {
    $('.pop3').addClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop').removeClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop1').removeClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop2').removeClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop3').removeClass('act-pop')
  })
})

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.comercio
  padding: 80px 0
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    width: 100%
    position: relative
    z-index: 2
  .cont-1170
    max-width: 1170px
    display: flex
    flex-direction: column
    align-items: center
    padding-top: 40px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    position: relative
    z-index: 2
    img
      max-width: 800px
      width: 100%
      margin: 0 auto
    video
      max-width: 1000px
      width: 100%
      margin: 0 auto
      padding-top: 50px
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 25px
.cont-1300
  display: flex
  align-items: center
  max-width: 1300px
  width: 100%
  padding: 0 15px
  margin: 0 auto
  @media(max-width: 800px)
    flex-direction: column
  .left
    width: 50%
    padding: 0 50px
    @media(max-width: 800px)
      width: 100%
      padding: 30px 10px
    h2
      font-size: 30px
      color: #004d9e
      position: relative
      margin-bottom: 60px
      &:after
        width: 80px
        height: 1px 
        background: #333
        content: ''
        position: absolute
        bottom: -30px
        left: 0
    p
      font-size: 16px 
      line-height: 30px
      color: #323232
  .right
    width: 50%
    position: relative
    cursor: pointer
    @media(max-width: 800px)
      width: 100%
      margin-bottom: 20px
    video, img
      width: 100%
.instalaciones
  background: #f3f3f3
  padding: 80px 0
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    width: 100%
    position: relative
    z-index: 2
  .cont-1299
    max-width: 1300px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    position: relative
    z-index: 2
    .mod
      display: flex
      align-items: flex-start
      max-width: 1170px
      background: #fff
      width: 100%
      padding: 0
      position: relative
      margin: 40px auto
      @media(max-width: 800px)
        flex-direction: column
      video
        width: 100%
      .pop, .pop1, .pop2, .pop3
        width: 90%
        height: 100%
        background: #000
        opacity: 0
        position: absolute
        top: 0
        left: 50%
        transform: translateX(-50%)
        display: flex
        justify-content: center
        z-index: 0
        align-items: center
        height: auto
        transition: all .45s ease-in-out
        &.act-pop
          opacity: 1
          z-index: 999
        .close
          font-size: 25px
          color: #fff
          position: absolute
          right: 20px
          top: 20px
          cursor: pointer
        video
          width: 100%
          box-shadow: 3px 3px 15px #000
      .derecha
        width: 50%
        padding: 40px
        z-index: 99
        @media(max-width: 800px)
          width: 100%
          padding: 30px
          height: auto
        h3
          color: #004d9e
          font-size: 18px
          text-transform: uppercase
        p
          color: #323232
          font-size: 14px
          line-height: 26px
          margin-bottom: 40px
        a
          border: 1px solid #004d9e
          padding: 7px 12px
          background: #fff
          color: #004d9e
          cursor: pointer
          font-size: 15px
          text-decoration: none
          margin: 40px auto
      .zurda
        width: 50%
        @media(max-width: 800px)
          width: 100%
          height: auto
        .owl-carousel
          width: 100%
          position: relative
          .slide1
            width: 100%
            height: 560px
            display: flex
            background: #000
            @media(max-width: 800px)
              height: auto
            video 
              width: 100%
            a
              width: 100%
          .slide2
            width: 100%
            height: 560px
            @media(max-width: 800px)
              height: auto
          .owl-dots
            position: absolute !important
            bottom: 40px
            left: 50%
            transform: translateX(-50%)
            .owl-dot
              border-radius: 50%
              border: 1px solid red
              background: #fff
      .derechas
        width: 50%
        padding: 40px
        @media(max-width: 800px)
          width: 100%
          height: auto
      .zurdas
        width: 50%
        display: flex
        background: #000
        align-items: center
        @media(max-width: 800px)
          height: auto
          width: 100%
        video 
          width: 100%
        .owl-carousel
          width: 100%
          position: relative
          .slide1
            width: 100%
            height: 390px
            @media(max-width: 800px)
              height: auto
          .slide2
            width: 100%
            height: 390px
            @media(max-width: 800px)
              height: auto
              width: 100%
            .owl-dots
              position: absolute
              bottom: 40px
              left: 50%
              transform: translateX(-50%)
              .owl-dot
                border-radius: 50%
                border: 1px solid red
                background: #fff
</style>




// WEBPACK FOOTER //
// src/components/quienes-somos/quienesSomos.vue